import React from 'react';
import { Card, CardContent, cn } from '@mf-tools/domains-ui';
import { Container } from '../components';

export interface WhyNowProps {
  className?: string;
}

export function WhyNow({ className }: WhyNowProps): React.ReactElement {
  return (
    <section className={cn('py-14 sm:py-20', className)} aria-labelledby="whynow-title">
      <Container>
        <div className="grid gap-8 lg:grid-cols-2 lg:items-start">
          <div className="space-y-4">
            <h2 id="whynow-title" className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
              The modern startup needs an operating system — not a pile of SaaS tools.
            </h2>
            <p className="text-base leading-relaxed text-muted-foreground sm:text-lg">
              Teams are leaner, expectations are higher, and customers demand security earlier. OpsPilott gives you the
              operating layer to scale without hiring a department.
            </p>
          </div>

          <Card>
            <CardContent className="p-6">
              <ul className="grid gap-3 text-sm text-muted-foreground">
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                  Startups are leaner than ever; expectations are higher than ever
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                  Tool sprawl is out of control
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                  Security/compliance is demanded earlier by customers &amp; investors
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary" aria-hidden="true" />
                  Automation enables ops without headcount
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </Container>
    </section>
  );
}

